import { useContext } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { AssignOrderModal } from "src/screens/tickets/ticket/details/actions/assignOrder/AssignOrderModal";
import { AssignOrderButton } from "src/screens/tickets/ticket/details/actions/assignOrder/AssignOrderButton";
import { RootStoreContext } from "src/stores/RootStore";
import { TICKET_STATE } from "src/stores/TicketStore";

const AssignOrderButtonAndModalBase = () => {
    const { ticketStore } = useContext(RootStoreContext);
    const isValidTicketState =
        ticketStore.currentTicket?.state === TICKET_STATE.NEW ||
        ticketStore.currentTicket?.state === TICKET_STATE.ASSIGNED ||
        ticketStore.currentTicket?.state === TICKET_STATE.COMISSIONED;

    if (!isValidTicketState) {
        return null;
    }

    return (
        <>
            <AssignOrderModal />
            <AssignOrderButton />
        </>
    );
};

export const AssignOrderButtonAndModal = Sentry.withProfiler(observer(AssignOrderButtonAndModalBase));
